module.exports = function getResource(label, vars = []) {
    let resources = {
        valueLabel: 'VALUE',
        valueLabelLower: 'value'
    };

    return resources[label];
};
